module.exports = __webpack_public_path__ + "img/Selo3.6e537a9c.svg";